import { Component, Input, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { TenantLiveClassesSectionSettings } from '../../../shared/services/tenant.service';
import { getResourcePath } from '../../../shared/util/helper.utils';

export interface LandingLiveClassSummary {
  id: string;
  title: string;
  subject?: string;
  targetAudience?: string;
  descriptionSummary?: string;
  bannerImageUrl?: string;
  price?: number;
  medium?: string;
  meetingsCount?: number;
  nextSessionTime?: string;
}

@Component({
  selector: 'black-live-classes-section',
  templateUrl: './live-classes-section.component.html',
  styleUrls: ['./live-classes-section.component.css'],
  standalone: true,
  imports: [CommonModule, RouterModule],
})
export class LiveClassesSectionComponent implements OnInit {
  private http = inject(HttpClient);

  @Input() settings?: TenantLiveClassesSectionSettings;
  @Input() theme: 'modern' | 'warm' | 'bold' = 'modern';
  @Input() tenantName?: string;

  liveClasses: LandingLiveClassSummary[] = [];
  loading = true;

  get sectionTitle(): string {
    return this.settings?.title || 'Upcoming Live Classes & Batches';
  }

  get sectionSubtitle(): string {
    return (
      this.settings?.subtitle ||
      'Interactive live Zoom sessions, structured syllabus coverage, and real-time doubt clearing.'
    );
  }

  ngOnInit(): void {
    if (this.settings && this.settings.enabled === false) {
      this.loading = false;
      return;
    }
    this.fetchLiveClasses();
  }

  fetchLiveClasses(): void {
    const limit = this.settings?.maxItems || 6;
    this.loading = true;

    this.http
      .get<{ docs?: any[]; totalDocs?: number }>(
        `${environment.host}/api/v1/live-class?limit=${limit}&status=PUBLISHED`
      )
      .subscribe({
        next: (res) => {
          this.loading = false;
          const docs = res?.docs || [];
          this.liveClasses = docs.map((c: any) => ({
            id: c.id || c._id,
            title: c.title,
            subject: c.subject,
            targetAudience: c.targetAudience,
            descriptionSummary: c.details?.descriptionSummary || '',
            bannerImageUrl: c.settings?.bannerImageResource
              ? getResourcePath(c.settings.bannerImageResource)
              : '',
            price: c.settings?.price,
            medium: c.details?.medium,
            meetingsCount: Array.isArray(c.meetings) ? c.meetings.length : 0,
            nextSessionTime: c.meetings?.[0]?.startTime || '',
          }));
        },
        error: () => {
          this.loading = false;
          this.liveClasses = [];
        },
      });
  }
}
